import script from "./CategoryProductList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryProductList.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryProductList.vue?vue&type=style&index=0&id=e53c34c4&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./CategoryProductList.vue?vue&type=custom&index=0&blockType=div"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e53c34c4"]])

export default __exports__